import React from "react";
import styled from "styled-components";
import {
  LuBrain,
  LuCloud,
  LuCodeXml,
  LuCpu,
  LuDatabase,
  LuServer,
  LuSmartphone,
} from "react-icons/lu";
import {
  Container,
  IconBox,
  Reveal,
  Section,
  SectionHeader,
  Tag,
  TagList,
} from "./ui";

const stack = [
  {
    title: "AI, ML & Deep Learning",
    icon: <LuBrain />,
    items: [
      "TensorFlow",
      "PyTorch",
      "Scikit-learn",
      "Keras",
      "OpenCV",
      "NLP & LangChain",
      "Pandas & NumPy",
      "MLOps",
    ],
  },
  {
    title: "Frontend",
    icon: <LuCodeXml />,
    items: ["React", "JavaScript", "TypeScript", "HTML & CSS"],
  },
  {
    title: "Backend",
    icon: <LuServer />,
    items: ["Node.js", "Python", "Java", "Spring Boot", "C#", ".NET"],
  },
  {
    title: "Mobile",
    icon: <LuSmartphone />,
    items: ["React Native", "Flutter", "Firebase", "App Store & Play Store"],
  },
  {
    title: "IoT & Hardware",
    icon: <LuCpu />,
    items: ["Arduino", "Raspberry Pi", "MQTT", "Sensors"],
  },
  {
    title: "DevOps & Cloud",
    icon: <LuCloud />,
    items: ["AWS", "Docker", "Kubernetes", "Git", "CI/CD"],
  },
  {
    title: "Data & Tooling",
    icon: <LuDatabase />,
    items: ["MongoDB", "PostgreSQL", "Database design", "API development", "Testing"],
  },
];

const Panel = styled.ul`
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
`;

const Row = styled(Reveal)`
  display: grid;
  grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
  align-items: center;
  gap: 32px;
  padding: 24px 32px;

  & + & {
    border-top: 1px solid var(--color-border);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 24px 20px;
  }
`;

const Category = styled.h3`
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 1.0625rem;
`;

const Skills = () => (
  <Section id="skills" $tone="subtle">
    <Container>
      <SectionHeader
        eyebrow="Tech stack"
        title="Technologies we work with"
        lead="Proven, well-supported tools chosen for each project's needs, from machine learning frameworks to cloud infrastructure."
      />

      <Panel>
        {stack.map(group => (
          <Row key={group.title} forwardedAs="li">
            <Category>
              <IconBox aria-hidden="true">{group.icon}</IconBox>
              {group.title}
            </Category>
            <TagList aria-label={`${group.title} technologies`}>
              {group.items.map(item => (
                <Tag key={item}>{item}</Tag>
              ))}
            </TagList>
          </Row>
        ))}
      </Panel>
    </Container>
  </Section>
);

export default Skills;
